import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

// ratings/fetchRatings is an action type prefix and is used
// internally with pending, fulfilled, rejected
// each of these createAsyncThunks return promises
export const fetchRatings = createAsyncThunk(
  "ratings/fetchRatings",
  async () => {
    console.log("calling GET ratings...");
    const response = await axios.get(`${BASE_URL}/api/ratings`);
    console.log("GET ratings response: ", response);
    return response.data;
  }
);

const ratingSlice = createSlice({
  name: "ratings",
  initialState: {
    ratings: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      // fetch ratings
      .addCase(fetchRatings.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRatings.fulfilled, (state, action) => {
        state.ratings = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchRatings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default ratingSlice.reducer;
